export default "__VITE_ASSET__CNiiddte__"